import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Button, Card, CardBody, Col, Container, Form, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';

import { reduxForm, SubmissionError, Field } from 'redux-form'
import { novopwd, reset } from '../../actions/authActions';
import { nextField } from '../../util/nextField';
import TooltipPassword from '../common/tooltipPassword/index'

import InputAuth from '../common/inputAuth'
import { validateMessages } from '../../constants/messages'
import { InputPassword } from '../common/InputPassword';

const NovoPwdFrom = ({
    hash,
    bgColorContainer,
    goBack,
    handleSubmit,
    boxTitle,
    bgColorBoxTitle,
    textColorBoxTitle,
    willCp = true,
    Private_IP = '0.0.0.0',
    Public_IP = '0.0.0.0'
}) => {
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');

    const dispatch = useDispatch();
    const sucesso = useSelector(state => state.authreducer.sucesso);

    useEffect(() => {
        if(sucesso) {
            toastr.success('Sucesso', 'Senha alterada com sucesso.');
        }
    }, [sucesso])

    const toastrOptions = {
        timeOut: 10000,
        component: (
            <ToastPasswordRules />
        )
      }

    function ToastPasswordRules() {
        return (
            <div>
                <p>A senha nova deve seguir as regras abaixo:</p>
                <ul>
                    <li>Ser diferente das 5 últimas senhas utilizadas</li>
                    <li>Possuir ao menos 14 caracteres</li>
                    <li>Possuir ao menos um número</li>
                    <li>Possuir ao menos um caractere maiúsculo</li>
                    <li>Possuir ao menos um caractere minusculo</li>
                    <li>Possuir ao menos um caractere especial</li>
                </ul>
            </div>
        )
    }

    const onSend = async () => {

        const ip = {
            Private_IP,
            Public_IP
        }

        /* Validação de erros pós submit do redux-form */
        let errors = {};

        if (!password1) {
            toastr.error('Atenção', validateMessages.passwordField);
            errors.password1 = validateMessages.campoObrigatorio;
        }

        if (!password2) {
            toastr.error('Atenção', validateMessages.confirmPasswordField);
            errors.password2 = validateMessages.campoObrigatorio;
        }

        if(Object.keys(errors).length > 0) {
            throw new SubmissionError(errors)
        }

        if (password1 !== password2) {
            toastr.error('Atenção', "Senhas não conferem.");
            return;
        }

        var strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,20})/g;
        if (!strongRegex.test(password1)) {
            toastr.error('Atenção', toastrOptions);
            return;
        }

        await dispatch(novopwd(hash, password1, password2, willCp, ip));
        dispatch(reset());
    };

    const handleEnter = (event) => {
        nextField(event);
    };

    return (
        <div className="app flex-row align-items-center">
            <Container>
                <Row className="justify-content-center">
                    <Col md="6">
                        <Card className="mx-4" style={{
                            backgroundColor: bgColorContainer || '',
                        }}>
                            {boxTitle && <Card md="8" style={{
                                        backgroundColor: bgColorBoxTitle,
                                        borderRadius: '0.25rem 0.25rem 0 0',
                                        borderStyle: 'none',
                                        margin: '0',
                                        padding: '12px 0 0 24px',
                                }}>
                                    <h1 style={{color: textColorBoxTitle, fontSize: '25px'}}>{boxTitle}</h1>
                                </Card>}
                            <CardBody className="p-4">
                                <Form className="mp-0 w-100" onSubmit={ handleSubmit(v => onSend(v))}>
                                    <h1>Criação de Senha <TooltipPassword /></h1>
                                    <InputGroup className="mb-3">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="icon-lock"></i>
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Field
                                            component={InputAuth}
                                            name="password1"
                                            placeholder="Senha"
                                            type="password"
                                            icon='lock'
                                            onChange={(e) => setPassword1(e.target.value)}
                                            onKeyDown={handleEnter}
                                        />
                                    </InputGroup>
                                    <InputGroup className="mb-4">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="icon-lock"></i>
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Field
                                            component={InputAuth}
                                            name="password2"
                                            type="password"
                                            id="password2"
                                            icon='lock'
                                            placeholder="Confirmar senha"
                                            onChange={(e) => setPassword2(e.target.value)}
                                            onKeyDown={handleEnter}
                                        />
                                    </InputGroup>
                                    <Button
                                        className="text-white"
                                        color="primary-smart"
                                        block

                                    >Enviar</Button>
                                    <Button
                                        type="button"
                                        color="secundary-smart"
                                        block
                                        onClick={goBack}
                                    >Voltar</Button>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
};

export default reduxForm({
    form: 'passwordChange'
  })(NovoPwdFrom);
